export default __webpack_public_path__ + "static/cover-fc682b0c4d85732dae5f5e330b8e9be1.png";